module.exports = __webpack_public_path__ + "media/images/emblems/Gachnang-Blazono-ddc7fa79e58fdfff312c513ab0b590eb.png";